import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MetaDataCard from "../../components/metaDataCard/MetaDataCard";
import { useDispatch, useSelector } from "react-redux";
import { getMetaDataCreate } from "../../actions/MetaDataAction";
import ReactPaginate from "react-paginate";

const AllPageMetaData = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [deleteSuccess, setDeleteSuccess] = useState(null);

  const { allMetaData, loading } = useSelector((state) => state.metaDataState);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMetaDataCreate);
  }, [deleteSuccess, dispatch]);
  const userPerPage = 6;
  const pageVisited = pageNumber * userPerPage;

  const displayUsers = allMetaData
    ? allMetaData
      .slice(pageVisited, pageVisited + userPerPage)
      .map((data) => {
        return <MetaDataCard key={data._id} data={data} setDeleteSuccess={setDeleteSuccess} />;
      })
    : "";

  const pageCount = allMetaData
    ? Math.ceil(allMetaData.length / userPerPage)
    : "";

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  return (
    <div style={{ marginTop: "40px" }}>
      <Link to={"/create-metadata"} className="Create_caseS-btn">
        Create new page metaData
      </Link>
      <div className="allmeta_card" style={{ marginTop: "40px" }}>
        {!allMetaData?.length ? (
          <div className="no_blog_div">no blogs</div>
        ) : (
          <div>
            <div className="Card_section">
              {loading
                ? "Loading...."
                : allMetaData
                  ? displayUsers
                  : allMetaData}
              {allMetaData ? (
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName={"paginationBtns"}
                  previousLinkClassName={"previousBtn"}
                  nextLinkClassName={"nextBtn"}
                  disabledClassName={"paginationDisable"}
                  activeClassName={"paginationActive"}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllPageMetaData;
